"use client";
import { useRouter } from "next/navigation";
import { c } from "@/lib/vster/theme";
import Icon from "@/components/vster/Icon";

// 목록 카드 요약 박스 우측의 AI 아이콘 — 클릭 시 상세의 'AI 질문' 탭(?tab=chat)으로 이동.
//   카드 전체가 <Link> 앵커라 중첩 앵커를 피하려고 span[role=button] + router.push 사용.
//   부모 카드 링크로의 전파·기본 이동은 stopPropagation/preventDefault 로 차단.
export default function AskAiButton({ docId }: { docId: number }) {
  const router = useRouter();
  const go = (e: React.MouseEvent | React.KeyboardEvent) => {
    e.preventDefault();
    e.stopPropagation();
    router.push(`/programs/${docId}?tab=chat`);
  };
  return (
    <span
      role="button"
      tabIndex={0}
      title="AI에게 이 공고 질문하기"
      aria-label="AI 질문"
      onClick={go}
      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") go(e); }}
      style={{
        flexShrink: 0, marginTop: 1, cursor: "pointer", display: "inline-flex",
        alignItems: "center", justifyContent: "center", borderRadius: 6, padding: 2,
      }}
    >
      <Icon name="auto_awesome" size={16} color={c.actionDark} fill={1} />
    </span>
  );
}
